import { useTracking } from 'react-tracking';
import { Box } from '@applatform/design-system';
import Feature from 'components/V1/Feature/Feature';
import Nav from './Nav/Nav';
import NavLink from './NavLink/NavLink';
import { ReactComponent as SignalIcon } from 'icons/signal.svg';
import { ReactComponent as PaymentsIcon } from 'icons/payments.svg';
import { ReactComponent as UsersIcon } from 'icons/users.svg';
import { ReactComponent as AccountIcon } from 'icons/account.svg';
import { ReactComponent as GettingStartedIcon } from 'icons/check-all.svg';
import { ReactComponent as ReportsIcon } from 'icons/file.svg';
import { ReactComponent as Logo } from 'icons/zai-logo.svg';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';

function SideNav() {
  const { Track } = useTracking({ module: 'SideNav' });
  const { environment } = useEnvironment();

  return (
    <Track>
      <Box css={{ textAlign: 'center', py: '$8' }}>
        <Logo width="97" height="38" aria-label="Zai" />
      </Box>
      <Nav>
        {environment === 'pre-live' && (
          <NavLink to="/getting-started" icon={GettingStartedIcon}>
            Getting Started
          </NavLink>
        )}
        <NavLink to="/" icon={SignalIcon}>
          Overview
        </NavLink>
        <NavLink to="/payments" icon={PaymentsIcon}>
          Payments
        </NavLink>
        <NavLink to="/users" icon={UsersIcon}>
          Users
        </NavLink>
        <Feature flag="data-export">
          <NavLink to="/reports" icon={ReportsIcon}>
            Reports
          </NavLink>
        </Feature>
        <NavLink to="/platform-profile" icon={AccountIcon}>
          Platform Profile
        </NavLink>
      </Nav>
    </Track>
  );
}

export default SideNav;
